import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { storeToRefs } from "pinia";
import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router/composables";
import { useAnimationFrameScroll } from "@/composables/sensors/animationFrameScroll";
import { useToolStore } from "@/stores/toolStore";
import ScrollToTopButton from "./ScrollToTopButton.vue";
import ToolsListTable from "./ToolsListTable.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ToolsList',
    props: {
        name: {
            type: String,
            default: "",
        },
        section: {
            type: String,
            default: "",
        },
        ontology: {
            type: String,
            default: "",
        },
        id: {
            type: String,
            default: "",
        },
        owner: {
            type: String,
            default: "",
        },
        help: {
            type: String,
            default: "",
        },
    },
    setup(__props) {
        const props = __props;
        library.add(faTimes);
        const router = useRouter();
        const scrollContainer = ref(null);
        const { scrollTop } = useAnimationFrameScroll(scrollContainer);
        const toolStore = useToolStore();
        const { loading } = storeToRefs(toolStore);
        const filterSettings = computed(() => {
            const newFilterSettings = {};
            Object.entries(props).forEach(([filter, value]) => {
                if (value && value !== "") {
                    newFilterSettings[filter] = value;
                }
            });
            return newFilterSettings;
        });
        onMounted(async () => {
            await toolStore.fetchTools(filterSettings.value);
        });
        const filterCount = computed(() => Object.keys(filterSettings.value).length);
        const itemsLoaded = computed(() => Object.values(toolStore.getToolsById(filterSettings.value)));
        function scrollToTop() {
            scrollContainer.value?.scrollTo({ top: 0, behavior: "smooth" });
        }
        function showAllTools() {
            router.push({ path: "/tools/list" });
        }
        return { __sfc: true, props, router, scrollContainer, scrollTop, toolStore, loading, filterSettings, filterCount, itemsLoaded, scrollToTop, showAllTools, FontAwesomeIcon, ScrollToTopButton, ToolsListTable, LoadingSpan };
    }
});
